export default __webpack_public_path__ + "static/media/Settings.0bbf8c42.svg";